module.exports = __webpack_public_path__ + "img/melia-resort.ce7a3225.jpg";